import { isPrincipalTokenWind } from "@bridgesplit/abf-react";
import { LoopRouteType, TokenListMetadata } from "@bridgesplit/abf-sdk";

import { OrcaWinder } from "./OrcaWinder";
import { BaseWinder } from "./BaseWinder";
import { PrincipalWinder } from "./PrincipalWinder";
import { LoopWinder } from "./types";

export class LoopWinderFactory {
    static create(
        routeType: LoopRouteType | undefined,
        inputToken: TokenListMetadata | undefined,
        principalTokenMint: string | undefined
    ): LoopWinder {
        if (routeType === undefined || !inputToken || !principalTokenMint) return new BaseWinder();
        // Special case: Orca
        if (routeType === LoopRouteType.Orca) {
            return new OrcaWinder();
        }

        // Standard cases
        const isPrincipalWind = isPrincipalTokenWind(principalTokenMint, inputToken?.mint);
        return isPrincipalWind ? new PrincipalWinder() : new BaseWinder();
    }
}
